import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesArticulos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Clasificacion", items: [
      { label: "Lineas", icon: "fas fa-bars", color: "#3b82f6", href: "/Lineas", desc: "Lineas de producto", enabled: !!user.menu_articulos },
      { label: "Marcas", icon: "far fa-copyright", color: "#6366f1", href: "/Marcas", desc: "Catalogo de marcas", enabled: !!user.menu_articulos },
      { label: "Familias", icon: "fas fa-users", color: "#8b5cf6", href: "/Familias", desc: "Familias de articulos", enabled: !!user.menu_articulos },
      { label: "Colecciones", icon: "fas fa-calendar-alt", color: "#06b6d4", href: "/Colecciones", desc: "Temporadas y colecciones", enabled: !!user.menu_articulos },
    ]},
    { section: "Articulos", items: [
      { label: "Composiciones", icon: "fas fa-percent", color: "#14b8a6", href: "/Composiciones", desc: "Composicion de tela", enabled: !!user.menu_articulos },
      { label: "Modelos", icon: "fas fa-tshirt", color: "#10b981", href: "/ListadoArticulos", desc: "Listado de modelos", enabled: !!user.menu_articulos },
    ]},
    { section: "Atributos", items: [
      { label: "Colores", icon: "fas fa-palette", color: "#f59e0b", href: "/Colores", desc: "Catalogo de colores", enabled: !!user.menu_articulos },
      { label: "Tallas", icon: "fas fa-ruler", color: "#ef4444", href: "/Tallas", desc: "Catalogo de tallas", enabled: !!user.menu_articulos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Articulos"
      descripcion="Catalogos de modelos, clasificacion y atributos"
      icono="fas fa-tshirt"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesArticulos;
